import type { WireArtifact } from '@logistics/contracts';
import { ago, stamp } from '../../lib/format';

type Line = Extract<WireArtifact, { kind: 'vehicle' }>['vehicles'][number];

const ISO_TIME = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/;

/** A timestamp as "2026-09-22 14:05 · 3 min ago"; anything else as it came. */
export function detailValue(value: string, at?: Date): string {
  if (!ISO_TIME.test(value) || Number.isNaN(Date.parse(value))) return value;
  return `${stamp(value)} · ${ago(value, at)}`;
}

/** Everything a truck's row shows when it opens: identity first, then what the record carried. */
export function vehicleFacts(
  line: Line,
  makeModel: string | undefined,
  at?: Date,
): { k: string; v: string }[] {
  const identity = [
    { k: 'Make & model', v: makeModel },
    { k: 'VIN', v: line.vin },
    { k: 'Plate', v: line.plate },
  ].filter((f): f is { k: string; v: string } => f.v !== undefined);
  const details = (line.details ?? []).map((d) => ({ k: d.label, v: detailValue(d.value, at) }));
  return [...identity, ...details];
}
